<div class="con">
  <div id="tecno-bg">
  </div>
  <ng-container>
    <a  class="reno-cup-banner"  >
      <img src="assets/img/tecno-cup-iraq/Tournament-Cover-1400--600-px.jpg" class="img-responsive  hidden-xs" >
      <img src="assets/img/tecno-cup-iraq/mobile-view-414x700.jpg" class="img-responsive hidden-lg hidden-md hidden-sm" alt="">
    </a>
  </ng-container>
  <!--  <ng-template #banner>-->
  <!--    <a target="_blank" class="reno-cup-banner"  href="https://www.gbarena.com/events/reno-6-pubg-mobile-cup-gulf/tournaments">-->
  <!--      <img src="assets/img/tecno-event/tecno-banner.jpg" class="img-responsive  hidden-xs" >-->
  <!--      <img src="assets/img/tecno-event/banner-mob-view.jpg" class="img-responsive hidden-lg hidden-md hidden-sm" alt="">-->
  <!--    </a>-->
  <!--  </ng-template>-->
  <perfect-scrollbar class="scroll-x-container">
    <div class="menu-container d-flex">
      <div class="container ">
        <div class="menu">
          <div class="item" routerLink="./home" routerLinkActive="active">
            <p>{{globalService.customLang.main_page}}</p>
          </div>
          <div class="item" routerLink="./tournaments" routerLinkActive="active">
            <p>{{globalService.customLang.tournament}}</p>
          </div>
          <div class="item" routerLink="./qualified-player" routerLinkActive="active">
            <p>{{globalService.customLang.qualified_player}}</p>
          </div>
          <div class="item" routerLink="./rules-terms" routerLinkActive="active">
            <p>{{globalService.customLang.rules_terms}}</p>
          </div>

        </div>

      </div>
      <ng-container *ngIf="globalService.langChosen === 'ar'; else english">
        <div class="language-button" (click)="languageChange('en')">
          <div class="lang-container">
            <img src="assets/img/Flag_of_Iraq.svg.webp" alt="">
            <p>كردي</p>

          </div>


        </div>
      </ng-container>
      <ng-template #english>

        <div class="language-button" (click)="languageChange('ar')">
          <div class="lang-container">
            <img src="assets/img/Flag_of_Iraq.svg.webp" alt="">
            <p>العربية</p>
          </div>
        </div>
      </ng-template>
    </div>

  </perfect-scrollbar>
  <div class="content-container">
  <div class="banner_container"  >
    <a target="_blank" href="https://www.tecno-mobile.com/iq/phones/product-detail/product/pova-3-5/#/">
      <img class="img-responsive hidden-xs" src="assets/img/tecno-cup-iraq/WEB-1300X150-edited.jpg" alt=""  >
      <img src="assets/img/tecno-cup-iraq/MOBILE-375X150.jpg" class="img-responsive  hidden-lg hidden-md hidden-sm" alt="">
      </a>

    </div>
    <div class="container">
      <router-outlet></router-outlet>

    </div>

  </div>

  <app-footer-reusable [backgroundBody]="'rgb(36 36 89)'"></app-footer-reusable>
</div>
